import { DEFAULT_BIG_NUMBER_CONFIG } from '@domain/dashboard/big-numbers/big-numbers.constants';
import { DEFAULT_CAMPAIGNS_FILTERS_CONFIG } from '@domain/campaigns/campaigns-filter/campaigns-filter.constants';

export const DEFAULT_USER_CONFIG = {
    BIG_NUMBER: DEFAULT_BIG_NUMBER_CONFIG,
    CAMPAIGN_TABLE: {},
    CAMPAIGNS_FILTERS: DEFAULT_CAMPAIGNS_FILTERS_CONFIG,
};

export const USER_CONFIG_TEXTS = {
    REQUEST_FAILED: 'Failed to load some preferences, using the default setting',
};
